module.exports = __webpack_public_path__ + "NCharishmaDevi-65a64775.png";